import { Pipe, PipeTransform, inject } from '@angular/core';
import { HelperService } from '../services/common/helper.service';
import { TextCaseType } from '../constants/text-case-user-enum';

@Pipe({
    name: 'dynamicLanguageField',
    standalone: true,
    pure: true
})
export class DynamicLanguageFieldPipe implements PipeTransform {
    private helperService = inject(HelperService);

    transform<T extends object>(obj?: T | null | undefined, fieldName?: string, returnPropOnly: boolean = false, textCaseType?: TextCaseType,): string | null {

        if (!fieldName) return '';

        let suffix = this.helperService.isArabic() ? 'Arabic' : 'English';
        const words = suffix.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g) || [];
        textCaseType = textCaseType ?? TextCaseType.Title;
        switch (textCaseType) {
            case TextCaseType.Upper:
                suffix = suffix.toUpperCase();
                break;
            case TextCaseType.Lower:
                suffix = suffix.toLowerCase();
                break;
            case TextCaseType.Title:
                suffix = words.map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
                break;
            case TextCaseType.Camel:
                suffix = words.map((w, i) => i === 0
                    ? w.toLowerCase()
                    : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
                    .join('');
                break;
            case TextCaseType.Pascal:
                return words.map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join('');
            default:
                return suffix;
        }

        const propName = `${fieldName}${suffix}`;
        if (!obj) return returnPropOnly ? propName : null;
        const value = obj[propName];
        if (typeof value === 'string' && value.trim() !== '') {
            return value;
        }
        return '';
    }

}
